let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9NdQS")).then(() => parcelRequire('9DuFq'));